<template>
  <v-card flat>
    <v-card-text >
      <div class="overflow-x-auto">
        <table class="builds-table black--text">
          <tbody>
            <tr>
              <td
                rowspan="6"
                class="text-align-bottom text-left sticky-col border-top border-left"
              >
                Level:
              </td>
              <DateColumn
                v-model="date"
                :colspan="getColspanForDate()"
                class="border-top"
              />
            </tr>
            <template v-if="noData">
              <tr>
                <td :colspan="getColspanForDate() + 1">
                  No builds available for this date.
                </td>
              </tr>
            </template>
            <template v-else-if="loadingBuilds">
              <tr>
                <td :colspan="getColspanForDate() + 1">
                  Loading builds...
                </td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <td
                  v-for="map_alias in Object.keys(builds)"
                  :key="map_alias + '_map_alias'"
                  :colspan="getColspanForMapId(map_alias)"
                >
                  {{ map_alias }}
                </td>
              </tr>
              <tr>
                <template
                  v-for="map_alias in Object.keys(builds)"
                >
                  <td
                    v-for="build in builds[map_alias]"
                    :key="map_alias + '_' + build.id + '_build_id'"
                    :colspan="getColspanForBuildId()"
                    :class="{
                      [getBuildsColor(build.colors)]: true
                    }"
                  >
                    {{ build.build_id }}
                  </td>
                </template>
              </tr>
              <tr>
                <template
                  v-for="map_alias in Object.keys(builds)"
                >
                  <template v-for="build in builds[map_alias]">
                    <td
                      :colspan="getColspanForOptimization()"
                      :key="map_alias + '_' + build.id + '_optimization'"
                    >
                      Optimization
                    </td>
                    <td
                      colspan="2"
                      :key="map_alias + '_' + build.id + '_playtest'"
                    >
                      Playtest
                    </td>
                  </template>
                </template>
              </tr>
              <tr>
                <template
                  v-for="map_alias in Object.keys(builds)"
                >
                  <template v-for="build in builds[map_alias]">
                    <td
                      :key="map_alias + '_' + build.id + '_' + '_optimization'"
                      :colspan="getColspanForPlatform()"
                    >
                      {{ build.platform }}
                    </td>
                    <td
                      colspan="2"
                      :key="map_alias + '_' + build.id + '_playtest'"
                    />
                  </template>
                </template>
              </tr>
              <tr>
                <template
                  v-for="map_alias in Object.keys(builds)"
                >
                  <template
                    v-for="build in builds[map_alias]"
                  >
                    <td
                      v-for="category in categories"
                      :key="map_alias + '_' + build.id + '_' + '_category_' + category.id"
                    >
                      {{ category.title }}
                    </td>
                    <td :key="map_alias + '_' + build.id + '_' + '_qa_status'">
                      QA Status
                    </td>
                    <td :key="map_alias + '_' + build.id + '_internal_playtest'">
                      INT
                    </td>
                    <td :key="map_alias + '_' + build.id + '_external_playtest'">
                      EXT
                    </td>
                  </template>
                </template>
              </tr>
              <tr v-if="levelsLoading">
                <td :colspan="getColspanForDate() + 1">
                  Loading levels...
                </td>
              </tr>
              <template v-else>
                <tr v-for="level in levels" :key="level">
                  <td class="text-left sticky-col border-left">
                    {{ level }}
                  </td>
                  <template
                    v-for="map_alias in Object.keys(builds)"
                  >
                    <template
                      v-for="build in builds[map_alias]"
                    >
                      <SegmentsColumn
                        v-for="category in categories"
                        :key="map_alias + '_' + build.id + '_' + '_category_' + category.id + '_result'"
                        :loading="segmentsLoading[level]"
                        :level="level"
                        :category="category"
                        :segments="segments"
                        :build="build"
                        :platform="build.platform"
                      />
                      <QAStatus
                        :level="level"
                        :build="build"
                        :platform="build.platform"
                        :key="map_alias + '_' + build.id + '_' + '_qa_status_result'"
                      />
                      <PlaytestColumn
                        type="internal"
                        :map_alias="map_alias"
                        :level="level"
                        :build="build"
                        :platform="build.platform"
                        :key="map_alias + '_' + build.id + '_internal_playtest_result'"
                        @color="setBuildColor"
                      />
                      <PlaytestColumn
                        type="external"
                        :map_alias="map_alias"
                        :level="level"
                        :build="build"
                        :platform="build.platform"
                        :key="map_alias + '_' + build.id + '_external_playtest_result'"
                        @color="setBuildColor"
                      />
                    </template>
                  </template>
                </tr>
              </template>
            </template>
          </tbody>
        </table>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import DateColumn from '../components/builds-columns/DateColumn.vue';
import SegmentsColumn from '../components/builds-columns/SegmentsColumn.vue';
import QAStatus from '../components/builds-columns/QAStatus.vue';
import PlaytestColumn from '../components/builds-columns/PlaytestColumn.vue';

export default {
  components: {
    DateColumn,
    SegmentsColumn,
    QAStatus,
    PlaytestColumn
  },
  data () {
    let date = this.$route.query.date
    if (!date) {
      const now = new Date()
      date = `${now.getFullYear()}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getDate().toString().padStart(2, '0')}`
    }

    return {
      loadingBuilds: true,
      levelsLoading: true,
      segmentsLoading: {},
      date,
      noData: false,
      levels: [],
      builds: {},
      categories: [],
      segments: {}
    }
  },
  async mounted () {
    await Promise.all([
      this.getBuilds(),
      this.getRuntimeCategories()
    ])
  },
  computed: {
    platforms () {
      return this.$store.state.platforms
    },
    getMapIds () {
      return Object.values(this.builds).map(build => build.map_id)
    },
    colspanForDate () {
      return 2
    }
  },
  watch: {
    async date () {
      this.updateRouterQuery()
      await this.getBuilds()
    },
    async builds () {
      await this.getUniqueLevels()
    },
    async levels () {
      await this.getSegments()
    }
  },
  methods: {
    getColspanForPlatform () {
      return this.categories.length + 1
    },
    getColspanForOptimization () {
      return this.getColspanForPlatform()
    },
    getColspanForBuildId () {
      return this.getColspanForOptimization() + 2
    },
    getColspanForMapId (map_alias) {
      return this.builds[map_alias].length * this.getColspanForBuildId()
    },
    getColspanForDate () {
      return Object.keys(this.builds).reduce((cols, map_alias) =>
        cols + this.getColspanForMapId(map_alias), 0
      )
    },
    getBuildsColor (colors = {}) {
      const map = {}

      Object.values(colors).forEach(color => {
        map[color] = (map[color] || 0) + 1
      })

      const sortedColors = Object.entries(map).sort((a, b) => {
        if (a[1] > b[1]) return 1;
        if (a[1] < b[1]) return -1;
        return 0;
      })

      const color = sortedColors[0] || ['white']
      return color[0]
    },
    async getBuilds () {
      this.loadingBuilds = true
      const { data } = await this.$axios.get(this.$store.getters.projectPath + '/builds', {
        params: {
          date: this.date
        }
      })
      .catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else if (data.length === 0) {
        this.noData = true
      } else {
        this.builds = data.reduce((acc, build) => {
          if (acc[build.map_alias]) {
            acc[build.map_alias].push(build)
          } else {
            acc[build.map_alias] = [build]
          }
          return acc
        }, {})
        this.noData = false
      }

      this.loadingBuilds = false
    },
    async getRuntimeCategories () {
      const { data } = await this.$axios.get(this.$store.getters.projectPath + '/runtime-categories/map', {
        params: {
          columns: ['title', 'id', 'category']
        }
      })
      .catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.categories = data
      }
    },
    async getUniqueLevels () {
      this.levelsLoading = true
      const { data } = await this.$axios.get(this.$store.getters.projectPath + '/configs/multi-map/all-map-names', {
        params: {
          map_id: this.getMapIds
        }
      })
      .catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.levels = data
      }

      this.levelsLoading = false
    },
    async getSegments () {
      await Promise.all(
        this.levels.map(level =>
          this.getSegmentsForLevel(level)
        )
      ).then(result => {
        this.segments = result.reduce((all, curr) => ({ ...all, ...curr }), {})
        Object.keys(this.segmentsLoading).forEach(level => {
          this.$set(this.segmentsLoading, level, false)
        })
      })
    },
    async getSegmentsForLevel (level) {
      this.$set(this.segmentsLoading, level, true)
      const { data } = await this.$axios.get(this.$store.getters.projectPath + '/builds/segments', {
        params: {
          level,
          date: this.date
        }
      })
      .catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        return data
      }
    },
    updateRouterQuery () {
      const flag = this.$route.query.date !== this.date

      if (flag) {
        this.$router.replace({
          path: this.$route.path,
          query: {
            ...this.$route.query,
            date: this.date
          }
        })
      }
    },
    setBuildColor (params) {
      const index = this.builds[params.map_alias].findIndex(build => build.build_id === params.build.build_id)
      if (index === -1) return;

      let colors = this.builds[params.map_alias][index].colors || {}

      if (params.color) {
        colors[params.currentId] = params.color
      } else {
        delete colors[params.currentId]
      }

      const build = { ...this.builds[params.map_alias][index], colors }
      const mapBuilds = [...this.builds[params.map_alias]]
      mapBuilds[index] = build

      this.$set(this.builds, params.map_alias, mapBuilds)
    }
  }
}
</script>

<style scoped>
.v-application .builds-table {
  width: 100%;
  border-spacing: 0px;
}

.v-application .builds-table td {
  text-align: center;
  padding: 4px 8px;
  border-bottom: thin solid rgb(0,0,0) !important;
  border-right: thin solid rgb(0,0,0) !important;
}

.v-application .builds-table td.border-left {
  border-left: thin solid rgb(0,0,0) !important;
}

.v-application .builds-table td.border-top {
  border-top: thin solid rgb(0,0,0) !important;
}

.text-align-bottom {
  vertical-align: bottom;
}

.sticky-col {
  position: sticky;
  left: 0;
  background-color: white;
  z-index: 1;
}
</style>